<template>
  <div class="assessment-question list-group-item p-3 mb-3">
    <div class="question">
      {{ questionNumber }}. {{ question.QuestionText }}
    </div>
    <div>
      <!-- <div @click="this.$refs[`question${question.Id}`].">More info, advice and resources</div> -->
      <div class="form-row">
        <a
          role="button"
          v-if="
            question.AdviceResources &&
              question.AdviceResources.length > 0 &&
              question.AdviceResources.trim() !== ''
          "
          @click="showAdviceResources = !showAdviceResources"
          @keydown.enter="showAdviceResources = !showAdviceResources"
          class="more-info"
          tabindex="0"
        >
          More info, advice and resources<span
            :class="showAdviceResources ? 'angle-up-green' : 'angle-down-green'"
          ></span>
        </a>
      </div>
      <div
        class="html-content advice"
        v-show="showAdviceResources"
        :ref="`question${question.Id}`"
        v-html="question.AdviceResources"
      ></div>
      <!-- RESPONSES -->
      <div class="form-row">
        <div role="group" class="col-12 col-lg-9 row response">
          <div
            class="col-12 col-md-3"
            v-if="
              question.PositiveResponse &&
                question.PositiveResponse.length !== 0
            "
          >
            <label class="checkbox">
              {{ question.PositiveResponse }}
              <input
                @change="responseChanged()"
                type="radio"
                v-model="question.SAT_SavedResponses.PositiveResponse"
                :checked="question.SAT_SavedResponses.PositiveResponse"
                :value="true"
                :id="`PositiveResponse${question.Id}`"
                :ref="`PositiveResponse${question.Id}`"
                :name="`responses${question.Id}`"
              />
              <span
                tabindex="0"
                role="checkbox"
                class="checkmark"
                :ref="`SpanPositiveResponse${question.Id}`"
                @keydown.space="responseKeyDown(1, question.Id)"
              ></span>
            </label>
          </div>
          <div
            class="col-12 col-md-3"
            v-if="
              question.NegativeResponse &&
                question.NegativeResponse.length !== 0
            "
          >
            <label class="checkbox"
              >{{ question.NegativeResponse }}
              <input
                @change="responseChanged()"
                type="radio"
                v-model="question.SAT_SavedResponses.NegativeResponse"
                :checked="question.SAT_SavedResponses.NegativeResponse"
                :value="true"
                :id="`NegativeResponse${question.Id}`"
                :ref="`NegativeResponse${question.Id}`"
                :name="`responses${question.Id}`"
              />
              <span
                tabindex="0"
                role="checkbox"
                class="checkmark"
                :ref="`SpanNegativeResponse${question.Id}`"
                @keydown.space="responseKeyDown(2, question.Id)"
              ></span>
            </label>
          </div>
          <div
            class="col-12 col-md-3"
            v-if="
              question.PartialResponse && question.PartialResponse.length !== 0
            "
          >
            <label class="checkbox"
              >{{ question.PartialResponse }}
              <input
                @change="responseChanged()"
                type="radio"
                v-model="question.SAT_SavedResponses.PartialResponse"
                :checked="question.SAT_SavedResponses.PartialResponse"
                :value="true"
                :id="`PartialResponse${question.Id}`"
                :ref="`PartialResponse${question.Id}`"
                :name="`responses${question.Id}`"
              />
              <span
                tabindex="0"
                role="checkbox"
                class="checkmark"
                :ref="`SpanPartialResponse${question.Id}`"
                @keydown.space="responseKeyDown(3, question.Id)"
              ></span>
            </label>
          </div>
          <div
            class="col-12 col-md-3"
            v-if="question.NotApplicable && question.NotApplicable.length !== 0"
          >
            <label class="checkbox"
              >{{ question.NotApplicable }}
              <input
                @change="responseChanged()"
                type="radio"
                v-model="question.SAT_SavedResponses.NotApplicable"
                :checked="question.SAT_SavedResponses.NotApplicable"
                :value="true"
                :id="`NotApplicableResponse${question.Id}`"
                :ref="`NotApplicableResponse${question.Id}`"
                :name="`responses${question.Id}`"
              />
              <span
                tabindex="0"
                role="checkbox"
                class="checkmark"
                :ref="`SpanNotApplicableResponse${question.Id}`"
                @keydown.space="responseKeyDown(4, question.Id)"
              ></span>
            </label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <a
            class="comment float-lg-right dont-break-out"
            v-if="question.ShowCommentBox"
            @click="toggleComment()"
            @keydown.enter="toggleComment()"
            tabindex="0"
          >
            {{ showComment ? "Remove" : "Show" }} comment
            {{ showComment ? "" : "(optional)" }}
          </a>
        </div>
      </div>
      <div v-if="question.ShowCommentBox" v-show="showComment">
        <p class="body">Optional comments:</p>
        <textarea
          class="text-field-4"
          aria-label="Optional comments"
          v-model="question.SAT_SavedResponses.Comment"
        />
        <div class="label-info">
          <span class="fas fa-exclamation-circle mr-2"></span>Do not record
          safeguarding concerns or personal data here. Report concerns to the
          NSPCC on
          <a class="label-info" href="tel:0808 800 5000">0808 800 5000</a>.
        </div>
         <div class="label-info">
          <span class="fas fa-exclamation-circle mr-2"></span>You must tick one of the 'yes', 'no' or 'partially met' response boxes in order for your comments to be saved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssessmentQuestion",
  data() {
    return {
      showAdviceResources: false,
      showComment: false
    };
  },
  created() {
    if (
      this.question.SAT_SavedResponses.Comment &&
      this.question.SAT_SavedResponses.Comment.length !== 0
    ) {
      this.showComment = true;
    }
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    questionNumber: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    toggleComment() {
      if (this.showComment) {
        this.question.SAT_SavedResponses.Comment = null;
      }
      this.showComment = !this.showComment;
    },
    inputChanged() {
      this.$emit("inputChanged");
    },
    responseKeyDown(res, questionId) {
      switch (res) {
        case 1:
          this.$refs[`PositiveResponse${questionId}`].checked = true;
          this.$refs[`PositiveResponse${questionId}`].focus();
          break;
        case 2:
          this.$refs[`NegativeResponse${questionId}`].checked = true;
          this.$refs[`NegativeResponse${questionId}`].focus();
          break;
        case 3:
          this.$refs[`PartialResponse${questionId}`].checked = true;
          this.$refs[`PartialResponse${questionId}`].focus();
          break;
        case 4:
          this.$refs[`NotApplicableResponse${questionId}`].checked = true;
          this.$refs[`NotApplicableResponse${questionId}`].focus();
          break;
      }

      this.question.SAT_SavedResponses.PositiveResponse = this.$refs[
        `PositiveResponse${questionId}`
      ].checked;
      this.question.SAT_SavedResponses.NegativeResponse = this.$refs[
        `NegativeResponse${questionId}`
      ].checked;
      this.question.SAT_SavedResponses.PartialResponse = this.$refs[
        `PartialResponse${questionId}`
      ].checked;
      this.question.SAT_SavedResponses.NotApplicable = this.$refs[
        `NotApplicableResponse${questionId}`
      ].checked;

    },
    responseChanged() {
      this.question.SAT_SavedResponses.PositiveResponse = this.$refs[
        `PositiveResponse${this.question.Id}`
      ].checked;
      this.question.SAT_SavedResponses.NegativeResponse = this.$refs[
        `NegativeResponse${this.question.Id}`
      ].checked;
      this.question.SAT_SavedResponses.PartialResponse = this.$refs[
        `PartialResponse${this.question.Id}`
      ].checked;
      this.question.SAT_SavedResponses.NotApplicable = this.$refs[
        `NotApplicableResponse${this.question.Id}`
      ].checked;
    }
  },
  watch: {
    question: {
      handler() {
        this.inputChanged();
      },
      deep: true
    }
  }
};
</script>

<style lang="sass" scoped></style>
